export default "__VITE_ASSET__D41UnABF__"